import _ from '@lodash';
import { useState, useEffect, useRef  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import axios from "@fuse/utils/axios";
import useToast from '@fuse/hooks/useToast';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import AlphabeticalSorting from '@fuse/utils/alphabeticalSort';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import AccessoriesDialog from './AccessoriesDialog';
import { Button } from '@material-ui/core';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import ActivityAgGridListingSameAsSam from '@fuse/components/ActivitieLogs/activitiesAgGridListingSameAsSam';

function ListView(props) {
	const table_name = "ACCESSORY";
	const router = useRouter();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const gridRef = useRef();
	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');	
	const [tabState, setTabState] = useState("seats");
	const [windowHeight, setWindowHeight ]  = useState(window.innerHeight - 330);
	const [accessory, setAccessory] = useState(null)
	const [accessoryId, setAccessorId] = useState(null)
	const skipHeader = [
		"id", "user_companies_id", "platform_customer_id",
		"entity_external_platform_id", "created_at",
		"updated_at", "original_info",
		"manufacturer", "accessory_category"
	]
	const [ loading, setLoading ] = useState(false);
	const [ accessoryCategoryMenu, setAccessoryCategoryMenu ] = useState([])
	const [ manufacturerMenu, setManufacturerMenu ] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs,setLogs] = useState([]);
	const [filterApplied, setFilterApplied] = useState(false);
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);

	const query_data = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.quick_filter
  );

	const tab_value = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.tab_value
  );

	function TabButton(props) {
		const { activeClass, tab, tabState, tabStateChange, ...restProps } = props;
		const isActive = tab === tabState;
		return (
				<Button 
					{...restProps} 
					onClick={() => tabStateChange(tab)} 
					className={restProps.className && isActive ? activeClass : ""}
				>
					{props.children}
				</Button>
		)
	}

	
	function Close(){
		setOpen(false)
		setTabState('seats')
	}
	
	function TabContainer(props) {
		const { tabState, tab } = props;
		const shouldRender = tab === tabState;
		return shouldRender ? props.children : <></>
	}


	const handleClose = () => {
		setAccessory(null)
	}

	
	function handleDelete(){
		axios.delete(`/accessory/delete/${accessory.id}`).then((res)=>{
			if(res.status === 201){
				toast.error(res.data.message);
			} else {
				handleClose()
				toast.success(res.data.message)
				props.refresh()
			}
		}).catch((err)=>{
			console.log(err)
			toast.error(err.data.message);
		})
	}

	function formatString(str){
		if(!str) return ''
		return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
	}
	
	const onGridReady = (params) => {
		gridRef.current = params;
		props.endUsersAccounts.forEach((list) => {
			for (const [fieldName, value] of Object.entries(list)) {
				if(value === '') list[fieldName] = `No ${formatString(fieldName)}`
			}
		})
		if (router.query.report_name === undefined) {
			loadInitialState (params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]))
		}else{
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}
	
	function onFilterChanged (event) {
		const rows = event.api.getFilterModel();
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		saveView("N/A", rows,gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function getReport(event){
		const { report_name } = router.query;
		const table_name = "accessory";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event.api?.getColumnState(row_model);
		})
		// autoGroupColumnDef={{ minWidth: 5000 }}
		.catch(err=>{
			console.log(err);
		})
	}

	function loadInitialState (params){
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
		.then(results=>{
			const { data } = results.data;
			if (data !== null) {
				const order = JSON.parse(data.order);
				const filter = JSON.parse(data.filter);
				gridRef.current = {...gridRef.current,filterModelArr:filter}
				params?.api?.applyColumnState({ state: order });
				params?.api.setFilterModel(filter);
				if (filter && Object.keys(filter)?.length) {
					setFilterApplied(true)
				}
			} else {
				gridRef.current = params
			}
		})
		.catch(err=>{
			console.log(err);
		})
  }

	function saveView (rows, filter, filterModelArr=null){
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter:  JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		}else{
			payload = {
				order:  JSON.stringify(rows),
				table_name
			}
		} 
		// const order = JSON.stringify(rows);
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
			console.log('view updated')
		})
		.catch(err=>{
			console.log(err);
		})
	}

	const onColumnMoved = (params) => {
		const rows = params.api?.getColumnState();
		saveView(rows);
		dispatch(setrowGroupModel(rows))
	}

	function onColumnVisible (params) {
		const rows = params.api?.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
			saveView(params.api.getColumnState());
		}
	}
	function onSortChanged(params){
		if (router.query.report_name === undefined) {
      const rows = params.api?.getColumnState();
			dispatch(setrowGroupModel(rows));
      saveView(rows);
    }
  }

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();

		if (groupedColumns.length === 0) {
			setGroupByArr([])
		}else{
			setGroupByArr(groupedColumns)
		}
		if (router.query.report_name === undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
			  dispatch(setrowGroupModel(rows));
			  saveView(rows);
			} else {
			  dispatch(setrowGroupModel(rows));
			}
		  }
	}

	const onColumnPinned = (params) =>{
		if (router.query.report_name === undefined) {
			const rows = params.api?.getColumnState();
			saveView (rows);
			dispatch(setrowGroupModel(rows))
		}
	}


	const generateHeaderLabel = (header) => {
		if (header === 'accessory_category_id') {
			return 'Accessory Category Name'
		} if (header === 'manufacturer_id') {
			return 'Manufacturer Name'
		} if (header === 'accessory_category_name') {
			return 'Accessory Category';
		} if (header === "manufacturer_name") {
			return 'Manufacturer';
		} if (header === "model_number") {
			return 'Model';
		} if (header === "accessory_name") {
			return 'Accessory';
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	useEffect(()=>{
		gridRef.current.api?.setQuickFilter(
			query_data
		);
	},[query_data])

	useEffect(() => {
		return () => {
				dispatch(setQuickFilter(null))
		}
	}, [])

	const fetchManufacturerSuggestions = () => {
		setLoading(true)
		axios.get("/manufacturers").then(response => {
			setLoading(false)
			const manufacturer = AlphabeticalSorting(response.data.data, 'manufacturer_name')
			setManufacturerMenu(manufacturer.map((item)=>{
				return{
					id: item.id,
					label: item.manufacturer_name
				}
			}))
		}).catch(err => {
			console.log('136=>',err);
			// toast.error('Something went wrong!')
		})
	}

	const fetchAccessoryCategorySuggestions = () => {
		axios.get('/accessory-category').then(response => {
			const accessory_category = AlphabeticalSorting(response.data.data, 'category_name')
			setAccessoryCategoryMenu(accessory_category.map((item)=>{
				return{
					id: item.id,
					label: item.accessory_category_name
				}
			}))
		}).catch(err => {
			console.log('164=>',err);
			// toast.error('Something went wrong!')
		})
	}

	useEffect(()=>{
		fetchAccessoryCategorySuggestions()
		fetchManufacturerSuggestions()
		// if(Object.keys(filterModel).length !== 0){
		// 	setTimeout(()=>{
		// 		gridRef.current.api.setFilterModel(filterModel);
		// 	},0)
		// }
	},[])

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleChildClick = (value) => {
		setTabValue(value)
  };

	// logs
	function formatLogs(data){
		return data.map((item)=>{
				return {
						id:item.id,
						action_id: `act${item.id}`,
						action_date_and_time: item.created_at,
						accessory_name: item?.accessory?.accessory_name ||  item.accessory_name,
						name: item.user_name,
						action: item.action_name,
						description: item.comment,
						previous_value: item.previous_data,
						current_value: item.current_data,
						field_name: item.action_field_name,
						user_role: item.user_role_name,
						company_name: item?.user_company?.company_name,
					}
		})
	}

	function getLogs(){
		setLoadingActivityLog(true)
			axios.get('/accessory/activities')
			.then(({data})=>{
				setLogs(formatLogs(data.data.activities));
				setLoadingActivityLog(false)
			})
			.catch(()=>{
				console.log('cannot fetch logs');
			})
	}


	useEffect(()=>{
		if (tabValue === 1) {
			getLogs()
			setFilterApplied(false)
		}
	},[tabValue])

	useEffect(()=>{
    setTabValue(tab_value)
	}, [tab_value])
	
	const columnDefs = Object.keys(props.endUsersAccounts?.[0] || {})
    .filter(header => !skipHeader.includes(header))
		.map(header => {
			const baseDef = {
				field: header,
				headerName: generateHeaderLabel(header),
				sortable: true,
				filter: "agTextColumnFilter",
				flex: 1,
				minWidth: 200,
				suppressSizeToFit: true,
				headerComponent: (pros) => CustomFilter(pros, header, gridRef),
			};

      if (header === 'manufacturer_name') {
        return {
          ...baseDef,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: manufacturerMenu.map(m => m.label)
          }
        };
      }

      if (header === 'accessory_category_name') {
        return {
          ...baseDef,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: accessoryCategoryMenu.map(a => a.label)
          }
        };
      }

      return baseDef;
    });

	return (
		<>
			{(tabValue === 0) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				 groupByArrFromList ={ groupByArr }
				tableName="Accessory" logs={logs} displayTableName="Accessories"
				 onClick={handleChildClick}
			/>}
			{/* {(tabValue === 1) && (<ActivityAgGridListing module={'Accessory'} logs={logs} displayTableName = {'Accessories'}/>)} */}
			{(tabValue === 1) && (<ActivityAgGridListingSameAsSam module="Accessory" logs={logs} displayTableName="Accessories"
				addPermission = {props.createSLAggrementPermission}
				loadingActivityLog={loadingActivityLog}
				/>)}
			{(tabValue === 0) && <div 
				className="ag-theme-alpine" 
				style={{
					width: "100%",
					height:windowHeight+105,
					fontSize:'12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme="legacy"
					onGridReady = { onGridReady }
					animateRows
					rowData = {props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={ rowGroupPanelShow }

					onColumnMoved = { onColumnMoved }
					onColumnPinned = { onColumnPinned }
					onColumnVisible = { onColumnVisible }
					onSortChanged = { onSortChanged }

					groupHeaderHeight ={1}
					components={frameworkComponents}
					floatingFiltersHeight = {40}

					// get filter model
					onFilterChanged = { onFilterChanged }	
					
					// on column group changed
					onColumnRowGroupChanged = { onColumnRowGroupChanged }
					
					pagination
					defaultColDef={{
						enableRowGroup:true,
						resizable: true
					}}
					columnDefs={columnDefs}
				/>

				<GeneralModal
					open={accessory}
					title="Delete Accessory"
					text={<h4>Are you sure to delete this Accessory named as <b>{accessory?.accessory_name}</b>?</h4>}
					handleClose={handleClose}
					handleConfirm={handleDelete}
				/>

				<AccessoriesDialog fullWidth={fullWidth} 
					maxWidth={maxWidth} 
					open={open} 
					setOpen ={setOpen} 
					Close={Close} 
					accessoryId={accessoryId}
					// classes={classes} 
					TabButton ={TabButton} 
					tabState={tabState} 
					setTabState={setTabState} 
					TabContainer={TabContainer}
				/>
			</div>}
		</>			
	);
}

export default ListView